import './PromptListStyle.sass';

import React from 'react';
import { Col, Row } from 'react-bootstrap';

import SubHeader from '../../../commonComponents/SubHeader/SubHeader';
import { EMPTY_PROMPT_ID, PROMPT_LIST_OPTIONS } from '../constants';

class PromptList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedId: 0,
    };
  }

  componentDidMount() {
    const promptId = this.props.pickPromptId(this.props.activeTab);
    this.handlePromptSelect(promptId);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.prompts?.length !== this.props.prompts?.length) {
      const promptId = this.props.pickPromptId(this.props.activeTab);
      this.handlePromptSelect(promptId);
    }
  }

  handlePromptSelect(promptId) {
    this.props.setPromptDetail(promptId);
    this.props.setCreateMode(false);
    this.props.loadPromptDetails(true);
    this.setState({
      selectedId: promptId,
    });
  }

  handleAddPrompt() {
    this.props.loadPromptDetails(false);
    this.props.setCreateMode(true);
    this.setState({ selectedId: EMPTY_PROMPT_ID });
  }

  renderListPrompt() {
    const { prompts } = this.props;
    const promptFilter =
      this.props.activeTab !== ''
        ? prompts.filter((p) =>
            p.type.toLowerCase().includes(this.props.activeTab.toLowerCase()),
          )
        : prompts;
    return promptFilter.map((prompt) => (
      <div key={prompt.id}>
        <div
          className={
            prompt.id !== this.state.selectedId
              ? 'promptName'
              : 'promptName selected'
          }
          onClick={() => this.handlePromptSelect(prompt.id)}
        >
          {prompt.name}
          {prompt.active && (
            <div className="btn-success activeLabel">
              <b>Active prompt</b>
            </div>
          )}
        </div>
      </div>
    ));
  }

  handleActiveTabChange(tab) {
    const newSelectedId = this.props.pickPromptId(tab);
    this.handlePromptSelect(newSelectedId);
    this.props.setActiveTab(tab);
  }

  render() {
    return (
      <div className="containerList">
        <div>
          <Row className="pl-0 promptTabsRow">
            <Col className="ml-0 pl-0 promptTabsCol">
              <SubHeader
                options={PROMPT_LIST_OPTIONS}
                onOptionChange={(tab) => this.handleActiveTabChange(tab)}
                activeOption={this.props.activeTab}
              />
            </Col>
            <Col className="plusContainer mt-0">
              <i
                className="fa fa-plus fa-lg"
                onClick={() => {
                  this.handleAddPrompt();
                }}
              />
            </Col>
          </Row>
        </div>
        {this.props.prompts.length > 0 ? (
          <div className="animated fadeIn">{this.renderListPrompt()}</div>
        ) : (
          <p className="noPrompts">No prompt has been created</p>
        )}
      </div>
    );
  }
}

export default PromptList;
